<template>
  <div
    id="divMapViewContainer"
    class="mv4" >
    <div
      v-if="apiData.MappableLocationCount === 0 && apiData.USDescription"
      class="tc">
      Only {{ apiData.USDescription }} data available for your selections.
    </div>
    <!-- <div
      v-if="apiData.USDescription"
      class="desc-block">
      <div class="b">
        {{ apiData.USDescription }}:
        <span v-html="USValueUnit" />
      </div>
      <div v-if="USShowCI">
        {{ USConfidenceInterval }}
      </div>
      <div v-if="USShowSampleSize">
        {{ USSampleSize }}
      </div>
    </div> -->
    <!-- <map-view
      v-if="apiData.MappableLocationCount > 0"
      :us-value-median="USValueMedian" /> -->

    <NationalMapView :us-value-median="USValueMedian"/>
    <div
      v-if="apiData.XXDescription"
      class="desc-block">
      <div class="b">
        {{ apiData.XXDescription }}: {{ XXValueUnit }}
      </div>
      <div v-if="XXShowCI">
        {{ XXConfidenceInterval }}
      </div>
      <div v-if="XXShowSampleSize">
        {{ XXSampleSize }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import isNumber from 'is-number';
import getUSDataAndMappableLocationCountFromLPData from './MapViewContainerUtil';
import NationalMapView from './Maps/NationalMap/NationalMapView';

export default {
  name: 'MapViewContainer',
  components: {
    NationalMapView,
  },
  data() {
    return {
      apiData: {},
    };
  },
  computed: {
    ...mapState({
      indicatorId: state => state.LP.indicatorId,
      stratFilters: state => state.LP.stratFilters,
      loadingLPData: state => state.LP.flags.loadingLPData,
      mapClassifierId: state => state.LP.mapClassifierId,
      mapClassifierCount: state => state.LP.mapClassifierCount,
      lku: state => state.lku,
      lpData: state => state.LP.lpData,
      dataTypes: state => state.dataTypes,
    }),
    USValueUnit() {
      if (isNumber(this.apiData.USDataValue)) {
        return `${Number(this.apiData.USDataValue).toFixed(this.decimalPlaces)}${this.dataValueUnitShort}${this.USFootnoteSymbol}`;
      } return this.USFootnoteSymbol;
    },
    USValueMedian() {
      return `${Number(this.apiData.USDataValue).toFixed(this.decimalPlaces)}`;
    },
    USConfidenceInterval() {
      return `95% CI (${Number(this.apiData.USLowCI).toFixed(this.decimalPlaces)} - ${Number(this.apiData.USHighCI).toFixed(this.decimalPlaces)})`;
    },
    USShowCI() {
      return isNumber(this.apiData.USDataValue)
          && isNumber(this.apiData.USLowCI) && isNumber(this.apiData.USHighCI);
    },
    USSampleSize() {
      return `n = ${Number(this.apiData.USSampleSize).toLocaleString()}`;
    },
    USShowSampleSize() {
      return isNumber(this.apiData.USDataValue) && isNumber(this.apiData.USSampleSize);
    },
    decimalPlaces() {
      return this.$store.getters['LP/decimalPlaces'];
    },
    dataValueUnitShort() {
      return this.$store.getters['LP/dataValueUnitShort'];
    },
    USFootnoteSymbol() {
      if (isNumber(this.apiData.USDataValue)) {
        if (this.apiData.USFootnoteSymbol) {
          return `<sup>${this.apiData.USFootnoteSymbol}</sup>`;
        }
        return '';
      }
      return this.apiData.USFootnoteSymbol;
    },
    XXValueUnit() {
      if (this.apiData.XXDataValue) {
        return `${Number(this.apiData.XXDataValue).toFixed(this.decimalPlaces)}${this.dataValueUnitShort}${this.XXFootnoteSymbol}`;
      } return this.XXFootnoteSymbol;
    },
    XXConfidenceInterval() {
      return `95% CI (${Number(this.apiData.XXLowCI).toFixed(this.decimalPlaces)} - ${Number(this.apiData.XXHighCI).toFixed(this.decimalPlaces)})`;
    },
    XXShowCI() {
      return isNumber(this.apiData.XXDataValue)
          && isNumber(this.apiData.XXLowCI) && isNumber(this.apiData.XXHighCI);
    },
    XXSampleSize() {
      return `n = ${Number(this.apiData.XXSampleSize).toLocaleString()}`;
    },
    XXShowSampleSize() {
      return isNumber(this.apiData.XXDataValue) && isNumber(this.apiData.XXSampleSize);
    },
    XXFootnoteSymbol() {
      if (isNumber(this.apiData.XXDataValue)) {
        if (this.apiData.XXFootnoteSymbol) {
          return `<sup>${this.apiData.XXFootnoteSymbol}</sup>`;
        }
        return '';
      }
      return this.apiData.XXFootnoteSymbol;
    },
  },
  watch: {
    lpData: {
      handler() {
        this.getUSDataAndMappableLocationCount();
      },
      // run handler immediately after the start of observation
      // so apiData is loaded when switching from table/chart to map
      immediate: true,
    },
  },
  methods: {
    getUSDataAndMappableLocationCount() {
      this.apiData = getUSDataAndMappableLocationCountFromLPData(this.lku, this.lpData);
    },


  },

};
</script>

<style scoped>
  .b {
    font-weight: bold;
  }

  .desc-block {
    text-align: center;
    line-height: 18px;
  }

  .tc {
    text-align: center;
  }

  .mv4 {
    margin:2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/MapViewContainer.vue